import { render } from "./ViewResendTemplate.vue?vue&type=template&id=4c94a862&scoped=true"
import script from "./ViewResendTemplate.vue?vue&type=script&lang=js"
export * from "./ViewResendTemplate.vue?vue&type=script&lang=js"

import "./ViewResendTemplate.vue?vue&type=style&index=0&id=4c94a862&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c94a862"]])

export default __exports__